export default "__VITE_ASSET__Hy4rdnYb__"